
import { Component, Vue } from "vue-property-decorator";
import Profile from "@/components/Profile.vue";

@Component({ components: { Profile } })
export default class FragnachHeader extends Vue {
    public profileDialogActive: boolean = false;
}
